import { render, staticRenderFns } from "./advert-action-complain.vue?vue&type=template&id=399e6b5b"
import script from "./advert-action-complain.vue?vue&type=script&lang=ts"
export * from "./advert-action-complain.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports